import template from './ongCardDetails.html';
import controller from './ongCardDetails.controller';
import './ongCardDetails.scss';

let ongCardDetailsComponent = {
  restrict: 'E',
  bindings: {
    details: '<'
  },
  template,
  controller
};

export default ongCardDetailsComponent;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/ongsList/ongCard/ongCardDetails/ongCardDetails.component.js